module.exports = require("./../../_gen/openfl/geom/Rectangle");